import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthService, HandleErrorsService, ModelAdminService } from '../app-services';

export const currentModelAdminResolver: ResolveFn<unknown> = () => {
  const modelAdminService = inject(ModelAdminService);
  const authService = inject(AuthService);
  const handleErrors = inject(HandleErrorsService);
  const credentials = authService.credentials;

  if (!credentials) {
    return throwError(() => new Error('Missing credentials'));
  }

  return modelAdminService.getModelAdmin(credentials.payload.id).pipe(
    map(result => result.data),
    catchError(err => {
      handleErrors.handleErrors(err);

      return throwError(() => err);
    }),
  );
};
